export const permissionAliases = {
  finance: ['finance', 'accounting'],
  administration: ['administration', 'settings'],
  'administration.access_control': ['administration.access_control', 'settings.permissions', 'settings.modules'],
  'administration.users': ['administration.users', 'settings.users'],
  'administration.departments': ['administration.departments', 'settings.departments'],
  'administration.permissions': ['administration.permissions', 'settings.permissions'],
  'administration.system_settings': ['administration.system_settings', 'settings.agency_profile'],
  'administration.integrations': ['administration.integrations', 'settings.integrations'],
  'administration.maintenance': ['administration.maintenance', 'settings.maintenance'],
  'administration.masters': ['administration.masters', 'settings.masters'],
  'administration.audit_logs': ['administration.audit_logs', 'settings.audit_logs'],
  'cms.templates': ['cms.templates', 'settings.templates'],
  'cms.faqs': ['cms.faqs'],
  'cms.media': ['cms.media'],
  'marketing.overview': ['marketing'],
  'crm.opportunities': ['crm', 'sales'],
  calendar: ['calendar', 'crm.opportunities', 'crm', 'sales'],
  crm: ['crm', 'sales'],
};

export const permissionCandidates = (moduleKey, action) => {
  if (!moduleKey) return [];
  const aliases = permissionAliases[moduleKey] || [moduleKey];
  const keys = [`${moduleKey}:${action}`, ...aliases.map((alias) => `${alias}:${action}`)];
  if (moduleKey.includes('.')) {
    keys.push(`${moduleKey.split('.')[0]}:${action}`);
  }
  return [...new Set(keys)];
};